import { render } from "./ServiceUpdate.vue?vue&type=template&id=1377ef51"
import script from "./ServiceUpdate.vue?vue&type=script&lang=js"
export * from "./ServiceUpdate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__